/**
 * @fileoverview gRPC-Web generated client stub for marginpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: marginpb/calllog.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.marginpb = require('./calllog_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.marginpb.CallLogServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.marginpb.CallLogServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.marginpb.ListCallLogRequest,
 *   !proto.marginpb.ListCallLogResponse>}
 */
const methodDescriptor_CallLogService_ListCallLog = new grpc.web.MethodDescriptor(
  '/marginpb.CallLogService/ListCallLog',
  grpc.web.MethodType.UNARY,
  proto.marginpb.ListCallLogRequest,
  proto.marginpb.ListCallLogResponse,
  /**
   * @param {!proto.marginpb.ListCallLogRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.ListCallLogResponse.deserializeBinary
);


/**
 * @param {!proto.marginpb.ListCallLogRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.marginpb.ListCallLogResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.ListCallLogResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.marginpb.CallLogServiceClient.prototype.listCallLog =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/marginpb.CallLogService/ListCallLog',
      request,
      metadata || {},
      methodDescriptor_CallLogService_ListCallLog,
      callback);
};


/**
 * @param {!proto.marginpb.ListCallLogRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.marginpb.ListCallLogResponse>}
 *     Promise that resolves to the response
 */
proto.marginpb.CallLogServicePromiseClient.prototype.listCallLog =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/marginpb.CallLogService/ListCallLog',
      request,
      metadata || {},
      methodDescriptor_CallLogService_ListCallLog);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.marginpb.CallLog,
 *   !proto.marginpb.UpdateCallLogResponse>}
 */
const methodDescriptor_CallLogService_UpdateCallLog = new grpc.web.MethodDescriptor(
  '/marginpb.CallLogService/UpdateCallLog',
  grpc.web.MethodType.UNARY,
  proto.marginpb.CallLog,
  proto.marginpb.UpdateCallLogResponse,
  /**
   * @param {!proto.marginpb.CallLog} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.UpdateCallLogResponse.deserializeBinary
);


/**
 * @param {!proto.marginpb.CallLog} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.marginpb.UpdateCallLogResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.UpdateCallLogResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.marginpb.CallLogServiceClient.prototype.updateCallLog =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/marginpb.CallLogService/UpdateCallLog',
      request,
      metadata || {},
      methodDescriptor_CallLogService_UpdateCallLog,
      callback);
};


/**
 * @param {!proto.marginpb.CallLog} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.marginpb.UpdateCallLogResponse>}
 *     Promise that resolves to the response
 */
proto.marginpb.CallLogServicePromiseClient.prototype.updateCallLog =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/marginpb.CallLogService/UpdateCallLog',
      request,
      metadata || {},
      methodDescriptor_CallLogService_UpdateCallLog);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.marginpb.ListCallLogPendingRequest,
 *   !proto.marginpb.ListCallLogPendingResponse>}
 */
const methodDescriptor_CallLogService_ListCallLogPending = new grpc.web.MethodDescriptor(
  '/marginpb.CallLogService/ListCallLogPending',
  grpc.web.MethodType.UNARY,
  proto.marginpb.ListCallLogPendingRequest,
  proto.marginpb.ListCallLogPendingResponse,
  /**
   * @param {!proto.marginpb.ListCallLogPendingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.marginpb.ListCallLogPendingResponse.deserializeBinary
);


/**
 * @param {!proto.marginpb.ListCallLogPendingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.marginpb.ListCallLogPendingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.marginpb.ListCallLogPendingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.marginpb.CallLogServiceClient.prototype.listCallLogPending =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/marginpb.CallLogService/ListCallLogPending',
      request,
      metadata || {},
      methodDescriptor_CallLogService_ListCallLogPending,
      callback);
};


/**
 * @param {!proto.marginpb.ListCallLogPendingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.marginpb.ListCallLogPendingResponse>}
 *     Promise that resolves to the response
 */
proto.marginpb.CallLogServicePromiseClient.prototype.listCallLogPending =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/marginpb.CallLogService/ListCallLogPending',
      request,
      metadata || {},
      methodDescriptor_CallLogService_ListCallLogPending);
};


module.exports = proto.marginpb;

